export const MAX_FILE_SIZE_BYTES = 20 * 1024 * 1024;
export const MAX_TOTAL_UPLOAD_BYTES = 100 * 1024 * 1024;

const MIME_BY_EXTENSION = {
  pdf: "application/pdf",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ppt: "application/vnd.ms-powerpoint",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  txt: "text/plain",
  csv: "text/csv",
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
};

export const formatFileSize = (bytes) => {
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(1)} KB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const stripExtension = (name) => {
  const lastDot = name.lastIndexOf(".");
  if (lastDot <= 0) {
    return name;
  }
  return name.slice(0, lastDot);
};

export const getExtension = (name) => {
  const lastDot = name.lastIndexOf(".");
  if (lastDot <= 0) {
    return "";
  }
  return name.slice(lastDot + 1).toLowerCase();
};

export const ensureExtension = (newName, originalName) => {
  const originalExt = getExtension(originalName);
  if (!originalExt) {
    return newName.trim();
  }
  const trimmed = newName.trim();
  if (!trimmed) {
    return originalName;
  }
  if (getExtension(trimmed) === originalExt) {
    return trimmed;
  }
  return `${stripExtension(trimmed)}.${originalExt}`;
};

export const getMimeType = (file) => {
  if (file.type) {
    return file.type;
  }
  const ext = getExtension(file.name);
  return MIME_BY_EXTENSION[ext] || "application/octet-stream";
};

export const readFileAsBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== "string") {
        reject(new Error("Failed to read file"));
        return;
      }
      const base64 = result.includes(",") ? result.split(",")[1] : result;
      resolve(base64);
    };
    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.readAsDataURL(file);
  });

export const validateUploadFiles = (filesWithMeta) => {
  const errors = [];
  let totalSize = 0;

  filesWithMeta.forEach((item) => {
    totalSize += item.size;
    if (item.size > MAX_FILE_SIZE_BYTES) {
      errors.push(`"${item.name}" exceeds the 20 MB limit (${formatFileSize(item.size)})`);
    }
  });

  if (totalSize > MAX_TOTAL_UPLOAD_BYTES) {
    errors.push(`Total upload size exceeds 100 MB (${formatFileSize(totalSize)})`);
  }

  return {
    valid: errors.length === 0,
    errors,
    totalSize,
  };
};

export const getFileSizeError = (size) => {
  if (size > MAX_FILE_SIZE_BYTES) {
    return `Exceeds 20 MB (${formatFileSize(size)})`;
  }
  return null;
};
